import { Col, Form, Row } from "antd";
import BackTitle from "./BackTitle";

export default function FormPage({ title, backButton, children, colProps, ...formProps }) {
  return (
    <div style={{maxWidth: 600}}>
      <BackTitle backEnabled={false} title={title} />
      <Form layout="horizontal" labelCol={{span: 10}} wrapperCol={{span: 14}}  {...formProps} autoComplete="off">
        {children}
      </Form>
    </div>
  );
}
